import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';

@Component({
  selector: 'app-project-location-details',
  template: `
    <fl-bit class="Location">
      <fl-bit class="Location-item">
        <fl-icon
          class="Location-icon"
          flTrackingLabel="FirstLocationIcon"
          [color]="IconColor.PRIMARY"
          [name]="'ui-pin-location'"
          [flMarginRight]="Margin.XXSMALL"
          [size]="IconSize.SMALL"
        ></fl-icon>
        <fl-bit class="Location-address">
          <fl-text>{{ displayLocation }}</fl-text>
        </fl-bit>
      </fl-bit>
      <fl-bit *ngIf="displayEndLocation" class="Location-item">
        <fl-icon
          class="Location-icon"
          flTrackingLabel="SecondLocationIcon"
          [color]="IconColor.ERROR"
          [flMarginRight]="Margin.XXSMALL"
          [name]="'ui-pin-location'"
          [size]="IconSize.SMALL"
        ></fl-icon>
        <fl-bit class="Location-address">
          <fl-text>{{ displayEndLocation }}</fl-text>
        </fl-bit>
      </fl-bit>
    </fl-bit>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./project-location-details.component.scss'],
})
export class ProjectLocationDetailsComponent {
  Margin = Margin;
  IconColor = IconColor;
  IconSize = IconSize;

  @Input() displayLocation: string;
  @Input() displayEndLocation?: string;
}
